import React from 'react';
import { Box } from '@rsos/components/capstone/base';
import { StartMessagesContainer } from './TF911.styles';
import TF911StartMessage from './TF911StartMessage';

/**
 * @param {Boolean} isCreatingConversation - Loading state for creating conversation
 * @param {Array} preconfiguredMessages - List of preconfigured messages
 * @param {Function} onSendMessageClick - Callback function for using the
 * preconfigured message to start the chat
 */
const TF911StartChatMessages = ({
  isCreatingConversation,
  preconfiguredMessages,
  onSendMessageClick,
}) => {
  return (
    <StartMessagesContainer>
      {preconfiguredMessages.map(message => {
        return (
          <Box key={message}>
            <TF911StartMessage
              isCreatingConversation={isCreatingConversation}
              message={message}
              onSendMessageClick={onSendMessageClick}
            />
          </Box>
        );
      })}
    </StartMessagesContainer>
  );
};

export default TF911StartChatMessages;
